import type { OnboardingAnswers, Question } from "../../../types/onboarding";
import { MultiSelectQuestion } from "./base/MultiSelectQuestion";

interface InterestsQuestionProps {
	question: Question;
	answers: OnboardingAnswers;
	onInputChange: (field: string, value: string | string[]) => void;
}

export function InterestsQuestion({
	question,
	answers,
	onInputChange,
}: InterestsQuestionProps) {
	return (
		<MultiSelectQuestion
			question={question}
			answers={answers}
			onInputChange={onInputChange}
			translationMappingKey="interests"
			placeholderTranslationKey="questions.interests.selectAllThatApply"
			eventPrefix="option"
			maxSelections={3}
		/>
	);
}
